
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import delle traduzioni
import itTranslation from './locales/it/translation.json';
import enTranslation from './locales/en/translation.json';
import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json';
import deTranslation from './locales/de/translation.json';
import ptTranslation from './locales/pt/translation.json';

// Risorse delle traduzioni
const resources = {
  it: {
    translation: itTranslation,
  },
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  de: {
    translation: deTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
};

i18n
  .use(LanguageDetector) // Rileva automaticamente la lingua del browser
  .use(initReactI18next) // Passa i18n down to react-i18next
  .init({
    resources,
    
    // Rilevamento automatico della lingua
    detection: {
      // Ordine delle strategie di rilevamento
      order: ['navigator', 'localStorage', 'sessionStorage', 'htmlTag'],
      
      // Chiavi per il localStorage
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      
      // Cache della lingua selezionata
      caches: ['localStorage'],
      
      // Non controllare i cookie
      checkWhitelist: false,
    },
    
    // Lingua di fallback se la lingua rilevata non è supportata
    fallbackLng: 'en',
    
    // Lingue supportate
    supportedLngs: ['it', 'en', 'es', 'fr', 'de', 'pt'],
    
    // Non caricare un namespace se non viene trovato
    load: 'languageOnly',
    
    debug: false,

    interpolation: {
      escapeValue: false, // React già fa l'escape
    },
    
    // Configurazioni aggiuntive
    cleanCode: true, // Pulisce il codice della lingua (es. en-US -> en)
    
    react: {
      useSuspense: false, // Evita problemi con il lazy loading
    }
  });

export default i18n;
